import { Box, Button, Modal, Text } from "@modernatx-internal/component-library";
import React from "react";

import { useFinder } from "@/finder/hooks/V2/useFinder";
import { pharmacyLogos } from "@/finder/utils/pharmacyLogos";

export interface ScheduleModalProps {
  buttonText: string;
  locationName?: string;
  mainBlockText: React.ReactNode;
  subBlockText: React.ReactNode;
  title: string;
}

interface ScheduleModalPropsWithModalHandlers extends ScheduleModalProps {
  closeModal: () => void;
  exitLink: string;
  isOpen: boolean;
}

export const ScheduleModal = ({
  buttonText,
  closeModal,
  exitLink,
  isOpen,
  locationName,
  mainBlockText,
  subBlockText,
  title
}: ScheduleModalPropsWithModalHandlers) => {
  const { showPharmacyLogos } = useFinder();
  const logoUrl = showPharmacyLogos && locationName ? pharmacyLogos[locationName] : undefined;

  return (
    <>
      {/* This invisible text node forces a fetch of the aeonik-light font file,
    to ensure that we can render all modal content immediately upon modal opening,
    without having to wait for a font file to be fetched*/}
      <Text
        weight="light"
        sx={{
          visibility: "hidden",
          position: "absolute",
          width: "0",
          height: "0",
          overflow: "hidden"
        }}
      >
        {"hidden text"}
      </Text>
      <Modal isOpen={isOpen} size={"xs"} onDismiss={closeModal}>
        {logoUrl ? (
          // eslint-disable-next-line @next/next/no-img-element
          <img
            src={logoUrl}
            alt={`${locationName} logo`}
            style={{ display: "block", height: "2.5rem", marginBottom: "1rem", maxWidth: "100%" }}
          />
        ) : (
          <Text
            as="p"
            size="font-size-7"
            weight="light"
            color="color-current-brand-700"
            sx={{ pb: "spacing-4" }}
          >
            {title}
          </Text>
        )}

        <Box sx={{ pb: "spacing-7" }}>{mainBlockText}</Box>
        <Button
          data-exiting-link={true}
          href={exitLink}
          data-track="schedule-final"
          target="_blank"
          icon="arrow-square-in"
          iconPosition="end"
          size="lg"
        >
          {buttonText}
        </Button>
        <Box sx={{ pt: "spacing-7" }}>{subBlockText}</Box>
      </Modal>
    </>
  );
};
